import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
/**
 * 级联组件，继承Base
 * @module $ui/components/my-cascader
 */

import { Cascader } from 'element-ui';
import Base from '../Base';
import { create as createTree } from '@/utils/tree';

/**
 * 插槽
 * @member slots
 * @property {string} default 作用域插槽， 自定义备选项的节点内容，参数为 { node, data }，分别为当前节点的 Node 对象和数据
 */

export default {
  name: 'MyCascader',
  mixins: [Base],
  components: {
    Cascader: Cascader
  },
  /**
   * 扩展参数
   * @member props
   * @property {*} [root] 数据项根节点的值
   */
  props: {
    value: [Array, String, Number],
    // 树的根节点，parentId的值
    root: {
      type: [String, Number, Boolean],
      default: null
    }
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      return [];
    }
  },
  computed: {
    optionsTree: function optionsTree() {
      var _this$keyMap = this.keyMap,
        id = _this$keyMap.id,
        parentId = _this$keyMap.parentId;
      return createTree(this.currentOptions || [], this.root, id, parentId);
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var scopedSlots = this.$scopedSlots.default ? {
      default: function _default(props) {
        return _this.$scopedSlots.default(props);
      }
    } : null;
    var vnode = h(Cascader, _mergeJSXProps([{
      "ref": 'comp',
      "class": 'my-cascader'
    }, {
      props: this.innerProps,
      on: _objectSpread({}, this.$listeners),
      // attrs: this.innerProps,
      scopedSlots: scopedSlots
    }, {
      "attrs": {
        "options": this.optionsTree
      },
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    }]), [this.createSlots(['empty'])]);
    return this.renderComponent(vnode);
  },
  mounted: function mounted() {
    this.extendMethods(this.$refs.comp, ['getCheckedNodes']);
  }
};